import styled from "styled-components/macro";

export const PdfSection = styled.section``;
